<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Areas Matrix</h4>
        </div>
         <!-- form = { origin: '', destination: '', transporter_mode: '', est_distance: ''} -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button @click="addFormInit" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
          <vs-button
            @click="viewData"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeData"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="showFilterForm = true"
            icon="filter_list"
          >Filter</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
              <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
              <input type="file" ref="file" style="display: none" v-on:change="uploadExcel" />
              <vs-dropdown-item @click="exportExcel({ endpoint: 'master/areasmatrix/report/exportexcel', name: 'areas-matrix', filter: filter })">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="data"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

      <!-- Form filter data -->
      <vs-prompt buttons-hidden title="Filter" :active.sync="showFilterForm">
        <div class="con-exemple-prompt">
          <label class="vs-input--label">Origin</label>
          <v-select
            @search="fetchArea"
            :options="area"
            v-model="filter.origin_id"
            :reduce="option => option.value"
            class="mb-3"
          ></v-select>
          <label class="vs-input--label">Destination</label>
          <v-select
            @search="fetchArea"
            :options="area"
            v-model="filter.destination_id"
            :reduce="option => option.value"
            class="mb-3"
          ></v-select>
          <label class="vs-input--label">Transporter Mode</label>
          <v-select
            @search="fetchTransporterMode"
            :options="transporter_mode"
            v-model="filter.transporter_mode_id"
            :reduce="option => option.value"
            class="mb-3"
          ></v-select>
          <vs-input v-model="filter.est_distance" class="mb-2 w-full" label="Est. Distance"  @keypress="isNumber($event)"
            maxlength="4"/>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" @click="filterData">Search</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form view data -->
      <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
        <div class="con-exemple-prompt">
          <label class="vs-input--label">Origin *</label>
          <v-select
            @search="fetchArea"
            :options="area"
            v-model="form.origin_id"
            :reduce="option => option.value"
            class="mb-3"
            :disabled="!editMode"
          ></v-select>
          <label class="vs-input--label">Destination *</label>
          <v-select
            @search="fetchArea"
            :options="area"
            v-model="form.destination_id"
            :reduce="option => option.value"
            class="mb-3"
            :disabled="!editMode"
          ></v-select>
          <label class="vs-input--label">Transporter Mode *</label>
          <v-select
            @search="fetchTransporterMode"
            :options="transporter_mode"
            v-model="form.transporter_mode_id"
            :reduce="option => option.value"
            class="mb-3"
            :disabled="!editMode"
          ></v-select>
          <vs-input
            v-model="form.est_distance"
            class="mb-2 w-full"
            label="Est. Distance *" 
            @keypress="isNumber($event)"
            maxlength="4"
            :disabled="!editMode"
          />
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mr-2" @click="editMode = true">Edit</vs-button>
            <vs-button color="primary" @click="saveData" :disabled="!editMode">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form add data -->
      <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
        <div class="con-exemple-prompt">
          <label class="vs-input--label">Origin *</label>
          <v-select
            @search="fetchArea"
            :options="area"
            v-model="form.origin_id"
            :reduce="option => option.value"
            class="mb-3"
          ></v-select>
          <label class="vs-input--label">Destination *</label>
          <v-select
            @search="fetchArea"
            :options="area"
            v-model="form.destination_id"
            :reduce="option => option.value"
            class="mb-3"
          ></v-select>
          <label class="vs-input--label">Transporter Mode *</label>
          <v-select
            @search="fetchTransporterMode"
            :options="transporter_mode"
            v-model="form.transporter_mode_id"
            :reduce="option => option.value"
            class="mb-3"
          ></v-select>
          <vs-input v-model="form.est_distance" class="mb-3 w-full" label="Est. Distance *" @keypress="isNumber($event)"
            maxlength="4"/>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" @click="addData">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      popupState: '',
      popupType: '',
      gridOptions: {},
      gridApi: null,
      data: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      selectedId: null,
      isLoading: false,
      editMode: false,
      filter: {
        origin_id: null,
        destination_id: null,
        transporter_mode_id: null,
        est_distance: "",
      },
      form: {
        origin_id: null,
        destination_id: null,
        transporter_mode_id: null,
        est_distance: "",
      },
      originOptions: [],
      destinationOptions: [],
      transportModeOptions: [],

      // Show forms
      showFilterForm: false,
      showViewForm: false,
      showAddForm: false,

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0,
      area: [],
      transporter_mode: []
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    saveData() {
      this.isLoading = true;
      this.$http
        .put("master/areasmatrix/" + this.selectedId + "/update", this.form)
        .then(res => {
          this.isLoading = false;
          this.editMode = false;
          this.showViewForm = false;
          this.selectedId = null;
          this.fetchData();
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          });
        })
        .catch(error => this.handleError(error))

    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("master/areasmatrix/store", this.form)
        .then(res => {
          this.isLoading = false;
          this.showAddForm = false;
          this.fetchData();
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          });
        })
        .catch(error => this.handleError(error))
    },
    removeData() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this data?",
        accept: () => {
          this.isLoading = true;
          this.$http
            .delete("master/areasmatrix/" + this.selectedId + "/destroy")
            .then(res => {
              this.$vs.notify({
                color: "success",
                title: "Data deleted",
                iconPack: "feather",
                icon: "icon-check",
                text: "The selected data was successfully deleted"
              });
              this.selectedId = null;
              this.fetchData();
            })
            .catch(error => this.handleError(error))
        }
      });
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    addFormInit() {
      this.form = {
        origin_id: null,
        destination_id: null,
        transporter_mode_id: null,
        est_distance: "",
      }
      this.showAddForm = true
    },
    fetchArea(search, loading) {
      loading(true)
      const data = {
          village: search
      }
      this.$http.post('master/areas', data)
      .then(res => {
        res.data.data.map(item => {
          const index = this.area.findIndex(a => a.value == item.id)
          if(index === -1) {
            this.area.push({
              value: item.id,
              label: item.village
            })
          }
        })
        loading(false)
      })
    },
    fetchTransporterMode(search, loading) {
      loading(true)
      const data = {
          mode: search
      }
      this.$http.post('master/transportersmode', data)
      .then(res => {
        res.data.data.map(item => {
          const index = this.transporter_mode.findIndex(a => a.value == item.id)
          if(index === -1) {
            this.transporter_mode.push({
              value: item.id,
              label: item.mode
            })
          }
        })
        loading(false)
      })
    },
    fetchData() {
      this.isLoading = true;
      Promise.all([
        this.$http.post(
          "master/areasmatrix?page=" + this.currentPage,
          this.filter
        ),
      ])
        .then(
          this.$http.spread((areasmatrix) => {
            this.data = areasmatrix.data.data;
            this.totalPage = areasmatrix.data.last_page;
            this.currentPage = this.currentPage;
            this.dataTotal = areasmatrix.data.total;
            this.dataFrom = areasmatrix.data.from;
            this.dataTo = areasmatrix.data.to;
            this.isLoading = false;
          })
        )
        .catch(err => {
          this.isLoading = false;
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Server Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
          return;
        });
    },
    fetchDropdown() {
      this.isLoading = true
      return Promise.all([
        this.$http.post(
          "master/areas",
        ),
        this.$http.post(
          "master/transportersmode",
        ),
      ]).then(
        this.$http.spread((areas, modes) => {
          areas.data.data.map(area => {
            if(this.area.findIndex(a => a.value == area.id) === -1) {
              this.area.push({
                value: area.id,
                label: area.village
              })
            }
          })

          modes.data.data.map(mode => {
            if(this.transporter_mode.findIndex(a => a.value == mode.id) === -1) {
              this.transporter_mode.push({
                value: mode.id,
                label: mode.mode
              })
            }
          })
        })
      )
    },
    viewData() {
      this.isLoading = true;
      this.$http
        .get("master/areasmatrix/" + this.selectedId)
        .then(res => {
          if(this.area.findIndex(a => a.value == res.data.origin_id) === -1) {
            this.area.push({
              value: res.data.origin_id,
              label: res.data.origin
            })
          }

          if(this.area.findIndex(a => a.value == res.data.destination_id) === -1) {
            this.area.push({
              value: res.data.destination_id,
              label: res.data.destination
            })
          }

          if(this.transporter_mode.findIndex(a => a.value == res.data.transporter_mode_id) === -1) {
            this.transporter_mode.push({
              value: res.data.transporter_mode_id,
              label: res.data.transporter_mode
            })
          }
          
          this.editMode = false
          this.form = res.data;
          this.showViewForm = true;
        })
        .catch(error => this.handleError(error))
        .then(() => (this.isLoading = false));
    },
    filterData() {
      this.currentPage = 1;
      this.showFilterForm = false;
      this.fetchData();
    },
    getTemplate() {
      this.isLoading = true;
      this.$http
        .get("master/areasmatrix/report/gettemplate", {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "areas-matrix-upload-template.xlsx");
        });
    },
    uploadExcel(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      this.isLoading = true;
      this.$http
        .post("/master/areasmatrix/report/importexcel", form, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(resp => {
          this.isLoading = false;
          this.fetchData();
          this.$vs.notify({
            color: "success",
            title: "Upload Success",
            text: "Upload Data Areas Matrix Successfully"
          });
        })
        .catch(error => {
          this.isLoading = false;
          const message = error.response.data.message
            ? error.response.data.message
            : "Something went wrong";
          this.$vs.notify({
            color: "danger",
            title: "Upload Failed",
            text: message
          });
        });
    },
  },
  mounted() {
    this.fetchDropdown().then(() => this.fetchData())
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Origin",
        field: "origin",
        width: 120,
      },
      {
        headerName: "Destination",
        field: "destination",
        width: 120,
      },
      {
        headerName: "Mode",
        field: "transporter_mode",
        width: 120
      },
      {
        headerName: "Est. Distance",
        field: "est_distance",
        width: 120
      }
    ];
    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
};
</script>

<style lang="css">
.wr_input {
  border-radius: 12px;
}
</style>